<template>
  <div class="Div">
    <section class="sectionContent">
      <labars-bread></labars-bread>
      <div class="details" v-if="detailBool">

        <div class="contents" v-if="type==1">

          <img
            :src="dataList.teacher_img"
            alt=""
          >
          <p class="ct">{{dataList.teacher_name_cn}}</p>
          <p class="position">{{dataList.position_name}}</p>
          <div v-html="dataList.teacher_introduce_cn">

          </div>
        </div>
        <div class="contents" v-else-if="type==2">

          <img
            :src="dataList.team_img"
            alt=""
          >
          <p class="ct">{{dataList.team_name_cn}}</p>
          
          <div v-html="dataList.team_content_cn">

          </div>
        </div>
      </div>
        <div class="msg"  v-if="!detailBool">
          {{msg}}
        </div>
    </section>
  </div>
</template>
<script>
import LabarsBread from "../../layout/LabarsBread";
import {teacherDetails,teacherTeamDetails} from '../../api/home'
export default {
  name: "NewsDetails",
  data() {
    return {
      laber: [],
      dataList:[],
      type:0,
      msg:'',
      detailBool:true
    };
  },
   components: {
    LabarsBread
  },
  methods:{
    // 顾问团队详情
    teamDetails(){
     var id= this.$route.query.id
     teacherDetails({teacher_id:id}).then(res=>{
      if(res.code==1){
       this.dataList=res.data
      }else{
        this.msg=res.msg
        this.detailBool=false
      }
     })
    },
    // 老师团队详情
    teacherDetails(){
      var id= this.$route.query.id
      teacherTeamDetails({team_id:id}).then(res=>{
      //  console.log(res.data)
       if(res.code==1){
       this.dataList=res.data
      }else{
        this.msg=res.msg
        this.detailBool=false
      }
     })
    }
  },
  created() {
    this.type=this.$route.query.type
    if (this.$route.query.type==1) {
      this.teamDetails()
    }else if(this.$route.query.type==2){
      this.teacherDetails()
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  width: 100%;
  min-height: 100%;
  padding: 0.1px 0;
  background: #f5f5f5;
}
.sectionContent {
  width: px2Rem(1300px);
  margin: auto;
  .details {
    // height: px2Rem(1160px);
    margin-bottom: px2Rem(80px);
    background: rgba(255, 255, 255, 1);
    .title {
      padding: px2Rem(26px) px2Rem(26px) px2Rem(16px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: center;
    }
    .author {
      padding-bottom: px2Rem(17px);
      border-bottom: 1px solid rgba(237, 236, 236, 1);
      font-size: px2Rem(16px);
      // font-family:STXinwei;
      font-weight: 400;
      color: rgba(102, 102, 102, 0.5);
      text-align: center;
      span {
        display: inline-block;
        margin-right: px2Rem(15px);
        vertical-align: top;
      }
    }
    .contents {
      padding: px2Rem(37px) px2Rem(30px) px2Rem(28px);
      font-size: px2Rem(24px);
      line-height: px2Rem(40px);
      img {
        display: block;
        max-width: 100%;
        margin: px2Rem(40px) auto;
      }
      .ct {
        margin-bottom: px2Rem(20px);
        text-align: center;
        font-size: px2Rem(30px);
        font-weight: 400;
      }
      .position{
        margin-bottom: px2Rem(20px);
        text-align: center;
        font-size: px2Rem(24px);
        font-weight: 400;
      }
    }
    .annex {
      padding: 0 px2Rem(30px) px2Rem(30px);
    }
  }
}
.msg {
  padding:40px;
 background: rgba(255, 255, 255, 1);
}
</style>


// WEBPACK FOOTER //
// src/views/index/TeacherDetail.vue